<app-base-drawer
  [name]="'filtersDrawer'"
  style="width: 22.125rem; z-index: 999"
>
  <div class="filters-drawer-wrapper">
    <header>
      <div class="headline-x-small">Filtros</div>
    </header>
    <div class="filters-wrapper">
      <!-- Radio button selection -->
      <ng-container *ngFor="let filter of filterDefs; let i = index">
      <div class="filter-group" *ngIf="i === 0 || (i === 1 && hasSelectedEstablishments())">
          <div class="filter-section" (click)="filter.expanded = !filter.expanded">
          <div class="headline-x-small">{{ filter.headerName }}</div>
          <i
            [ngClass]="{ 'icon-active': filter.expanded }"
            class="ri-arrow-down-s-line"
          ></i>
        </div>
        <div style="overflow: auto;" class="filter-content" [ngClass]="{ active: filter.expanded }">
          <div  class="filter-content-inner" *ngIf="filter.filterDefs.length > 0">
            <app-checkbox-item
            *ngIf="filter.type === 'checkbox' && filter.filterDefs.length > 0"
            [checked]="isAllSelected(filter)"
            (checkedChange)="toggleSelectAll(filter)"
            >
            <div class="body-small">Seleccionar todo</div>
          </app-checkbox-item>
            <ng-container  *ngFor="let option of filter.filterDefs">
              <ng-container *ngIf="filter.type === 'radio'">
                <yalo-radiobutton
                  noBorder
                  button
                  justify="start"
                  [name]="filter.field"
                  [buttonText]="option.label"
                  [checked]="option.selected"
                  (change)="onOptionChanged(option)"
                ></yalo-radiobutton>
              </ng-container>
  
              <ng-container *ngIf="filter.type === 'checkbox'">
                <app-checkbox-item
                  [(checked)]="option.selected"
                  (checkedChange)="onCheckboxChanged(option)"
                >
                  <div class="body-small">{{ option.label }}</div>
                </app-checkbox-item>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>

      <!-- <div class="filter-group" *ngFor="let column of columnDefs">
        <div class="filter-section">
          <div class="headline-x-small">{{ column.headerName }}</div>
          <i
            (click)="column.expanded = !column.expanded"
            [ngClass]="{ 'icon-active': column.expanded }"
            class="ri-arrow-down-s-line"
          ></i>
        </div>
        <div class="filter-content" [ngClass]="{ active: column.expanded }">
          <app-checkbox-item
            *ngFor="let filter of column.filterParams.filterOptions; index as i"
            [(checked)]="filter.selected"
            (checkedChange)="onFilterChanged()"
          >
            <div class="body-small">{{ filter.label }}</div>
          </app-checkbox-item>
        </div>
      </div> -->
    </div>
    <footer>
      <yalo-button type="secondary" (click)="clearFilters()">
        Restablecer
      </yalo-button>
      <yalo-button
        type="primary"
        (click)="closeDrawer()"
      >
        Aplicar
      </yalo-button>
    </footer>
  </div>
</app-base-drawer>
